<template>
  <div class="game-detail" :class="{ 'no-header': item.title === null }">
    <div class="title" :class="{ active: toggle, hidden: item.title === null }">
      <div class="cover" @click="toggle = false"></div>
      <div class="current-display" @click="openList">
        <div class="row">
          <span>{{ currentTitle }}</span>
          <i
            class="el-icon-caret-bottom"
            :style="{ visibility: previewList.length ? 'visible' : 'hidden' }"
          ></i>
        </div>
        <div class="list">
          <div
            class="item row"
            v-for="(item, ind) in previewList"
            :key="ind"
            @click.stop="changeArticle(item.id)"
          >
            <span>{{ item.title }}</span> <i class="el-icon-caret-bottom"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="context" v-html="currentContext"></div>
  </div>
</template>
<script>
import { getArticleLContext } from "@/api/api";
export default {
  name: "GameDetail",
  props: ["list", "item"],
  data() {
    return {
      index: -1,
      toggle: false,
      loading: true,
      localItem: {}
    };
  },
  watch: {
    index(nv, ov) {
      if (ov !== -1 || !this.item || !this.item.content) {
        // const target = this.list.find((e) => e.id === nv);
        this.fetchData(nv);
      }
    }
  },
  created() {
    console.log(this.item)
  },
  mounted() {
    
    if (this.list.length > 0) this.index = this.list[0].id;
    
    if (this.item) {
      this.localItem = Object.assign({}, this.localItem, this.item);
    }
  },
  computed: {
    currentItem() {
      return this.item || {};
    },
    currentContext() {
      const target = Object.assign({}, this.currentItem, this.localItem);
      return `<div>${
        target.summary ? "<p>" + target.summary + "</p><br/>" : ""
      }${target.content || ""}</div>`;
    },
    currentTitle() {
      const target = Object.assign({}, this.currentItem, this.localItem);
      return `${target.title || ""}`;
    },
    previewList() {
      const ref = [...this.lists];
      return ref.filter(e => e.id !== this.index);
    },
    lists() {
      let result = [];
      if (Array.isArray(this.list)) {
        result = this.list;
      } else {
        result = [this.list];
      }

      return result;
    }
  },
  methods: {
    fetchData(id) {
      id = parseInt(id);
      console.log(id)
      getArticleLContext(id).then(rv => {
        const { code, data, msg } = rv.data;
        if (data.title && data.content) {
          this.localItem = Object.assign({}, this.localItem, data);
        }
      });
    },
    openList() {
      if (this.previewList.length > 0) this.toggle = !this.toggle;
    },
    changeArticle(id) {
      this.index = id;
      this.$nextTick(() => {
        this.toggle = false;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.game-detail {
  margin-top: 30px;
  max-height: inherit;
  overflow: auto;
  &.no-header {
    margin-top: 0;
  }
  .title {
    &.hidden {
      visibility: hidden;
    }
    .cover {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 3;
      // background: rgba(0, 0, 0, 0.2);
      display: none;
    }
    position: absolute;
    top: -20px;
    left: 0;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;

    .current-display {
      // border: 2px solid #f1c24099;
      // border-radius: 5px;
      // background: rgba(255, 255, 255, 0.3);
      background: white;
      box-sizing: border-box;
      z-index: 4;
      position: relative;
      padding: 3px;
      overflow: visible;
      border-radius: 3px;
      transition: all 0.16s ease;
      .row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: all 0.3s ease;

        padding: 0px 0;
        color: inherit;
        &.item i {
          visibility: hidden;
        }
      }
      span {
        font-weight: 600;
        width: 100%;
      }
      i {
        transition: all 0.16s ease;
        color: #ee6723;
      }
    }

    .list {
      max-height: 0;
      transition: all 0.16s;
      overflow: auto;
      width: 100%;
      z-index: 4;
      position: relative;
      background: rgba(255, 255, 255, 1);
      border-radius: 0 0 5px 5px;
      padding: 0px 0;
      .item {
        margin: 8px 0;
        font-weight: 200;
        position: relative;
        color: #56555c;

        &.active {
          color: #ff8e1a;
        }
      }
    }
    &.active {
      .list {
        max-height: 50vh;
        padding: 10px 0;
      }
      .cover {
        display: block;
      }
      // .list,
      .current-display {
        box-shadow: 0px 4px 8px #888;
        & > .row {
          // background: #f3db3373;
          color: #ff9432;
          padding: 15px 0;
        }
      }
    }
  }
  .context {
  }
}
</style>



// WEBPACK FOOTER //
// src/components/items/GameDetail.vue